import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { loadAccounts } from '~/api/data/accounts/queries';
import {
  submitCancelBusinessPolicy,
  submitCreateBusinessPolicy,
  submitDeleteBusinessPolicy,
  submitDeleteFile,
  submitReinstateBusinessPolicy,
  submitRenewBusinessPolicy,
  submitUpdateBusinessPolicy,
  submitUploadPolicyFile
} from '~/api/data/policies/mutations';
import {
  loadBusinessPolicies,
  loadBusinessPolicy,
  loadInsuranceCarriers
} from '~/api/data/policies/queries';
import { loadAgencyUsers } from '~/api/data/users/queries';
import {
  PoliciesPage,
  PolicyCreatePage,
  PolicyDocumentUploadPage,
  PolicyDocumentsPage,
  PolicyEditPage,
  PolicyOverviewPage,
  PolicyPage
} from '~/pages/policies/policies';

export const policyRoutes: RouteObject[] = [
  {
    path: 'policies',
    loader: merge({
      businessPolicies: loadBusinessPolicies
    }),
    element: <PoliciesPage />,
    children: [
      {
        id: 'policies/new',
        path: 'new',
        loader: merge({
          accounts: loadAccounts,
          agencyUsers: loadAgencyUsers,
          carriers: loadInsuranceCarriers
        }),
        shouldRevalidate: () => false,
        action: byMethod({
          POST: submitCreateBusinessPolicy
        }),
        element: <PolicyCreatePage />
      }
    ]
  },
  {
    id: 'policies/:id',
    path: 'policies/:id',
    loader: merge({
      businessPolicy: loadBusinessPolicy
    }),
    action: byMethod({
      DELETE: submitDeleteBusinessPolicy
    }),
    element: <PolicyPage />,
    children: [
      {
        index: true,
        element: <Navigate to="overview" replace />
      },
      {
        path: 'cancel',
        action: byMethod({
          POST: submitCancelBusinessPolicy
        })
      },
      {
        path: 'renew',
        action: byMethod({
          POST: submitRenewBusinessPolicy
        })
      },
      {
        path: 'reinstate',
        action: byMethod({
          POST: submitReinstateBusinessPolicy
        })
      },
      {
        path: 'edit',
        loader: merge({
          businessPolicy: loadBusinessPolicy,
          agencyUsers: loadAgencyUsers,
          carriers: loadInsuranceCarriers
        }),
        action: byMethod({
          PUT: submitUpdateBusinessPolicy
        }),
        element: <PolicyEditPage />
      },
      {
        path: 'overview',
        element: <PolicyOverviewPage />
      },
      {
        path: 'documents',
        element: <PolicyDocumentsPage />,
        action: byMethod({
          DELETE: submitDeleteFile
        }),
        children: [
          {
            path: 'new',
            action: byMethod({
              POST: submitUploadPolicyFile
            }),
            element: <PolicyDocumentUploadPage />
          }
        ]
      }
    ]
  }
];
